var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-breadcrumb',{staticStyle:{"padding":"16px 0","background":"#f0f2f5"}},_vm._l((_vm.breadcrumbs),function(item){return _c('a-breadcrumb-item',{key:item.key},[_vm._v(_vm._s(item.title))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }